import React from 'react';
import { Badge, Table } from 'reactstrap';
import { partial } from '../../../util/translation/translation';
import Pagination from '../../../shared/components/pagination/Pagination';
import FormCard from '../../../shared/components/custom/FormCard';

const s = partial('shared');
const UnassingedUsersList = ({
  title,
  tierUsers,
  totalItems,
  onChangePage,
}) => {
  const renderUnassingedUserList = () => {
    return tierUsers.map((user) => {
      return (
        <tr key={`UnassingedUser-${user.userCloudId}`}>
          <td>
            {user.userEmail || (
              <Badge pill color="secondary">
                {s('empty')}
              </Badge>
            )}
          </td>
          <td>
            {user.userPhoneNumber || (
              <Badge pill color="secondary">
                {s('empty')}
              </Badge>
            )}
          </td>
          <td>
            <Badge pill color="info">
              {user.provider}
            </Badge>
          </td>
        </tr>
      );
    });
  };
  // const renderSort = () => {
  //   return reverse ? <ArrowUpIcon size={16} /> : <ArrowDownIcon size={16} />;
  // };

  return (
    <>
      <FormCard title={title} bodyClassName="form-card__body--flush">
        <Table striped responsive className="table--roomy">
          <thead>
            <tr>
              <th>{s('email')}</th>
              <th>{s('phone')}</th>
              <th>{s('provider')}</th>
            </tr>
          </thead>
          <tbody>{renderUnassingedUserList()}</tbody>
        </Table>
      </FormCard>
      <Pagination items={totalItems} onChangePage={onChangePage} />
    </>
  );
};

export default UnassingedUsersList;
